import React, { Fragment, useEffect, useState } from 'react'
import HomeScreen from './HomePage'
import ParentRef from '../parentRef/ParentRef'
import useApp from 'utils/hooks/useApp'
function HomePage() {
    const { app } = useApp()
    const [parentRefSubmitted, setParentRefSubmitted] = useState(false)
    // This state is for if the user is login then get the user from custom data else take user from local storage
    const [parentRef, setParentRef] = useState(
        app?.currentUser
            ? app.currentUser.customData.parentRef
            : localStorage.getItem('parentRef')
    )
    const[signupComplete, setSignupComplete]=useState(false)
    useEffect(()=>{
        if(app?.currentUser?.customData?.publishers?.length>0){
        const currentPublisherFromUser=  app?.currentUser?.customData?.publishers.find((publisher)=>{
         return publisher.publisher_id==localStorage.getItem('currentPublisher')
        })
         setSignupComplete(currentPublisherFromUser?.signup_complete||false)
    }
         },[])
    useEffect(() => {
        
        app?.currentUser?.refreshCustomData()
        
    }, [])

    return (
        <Fragment>
            {!signupComplete && !parentRef && !parentRefSubmitted && process.env.REACT_APP_FORCE_REF_SIGNUP==="TRUE" ? (
                <>
                    <div style={{marginBottom: '20px'}}>
                        <ParentRef
                            setParentRefSubmitted={setParentRefSubmitted}
                            parentRefSubmitted={parentRefSubmitted}
                        />
                    </div>
                    <HomeScreen />
                </>
            ) : !parentRef && parentRefSubmitted ? (
                <HomeScreen />
            ) : (
                <HomeScreen />
            )}
        </Fragment>
    )
}

export default HomePage
